/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Ermrouter_Page_Usermanagement2Inputs */

const en__ermrouter_page_usermanagement2 = /** @type {(inputs: _Ermrouter_Page_Usermanagement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Management`)
};

/**
* | output |
* | --- |
* | "User Management" |
*
* @param {_Ermrouter_Page_Usermanagement2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _ermrouter_page_usermanagement2 = /** @type {((inputs?: _Ermrouter_Page_Usermanagement2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Ermrouter_Page_Usermanagement2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__ermrouter_page_usermanagement2(inputs)
});
export { _ermrouter_page_usermanagement2 as "_ermRouter_page_userManagement" }